'use client';
import React, { useState, FormEvent } from 'react';
import { newsletterService } from '../../services/newsletterService';

interface NewsletterSubscriptionProps {
  placeholder?: string;
  buttonText?: string;
  className?: string;
}

export default function NewsletterSubscription({
  placeholder = 'Enter your email',
  buttonText = 'Subscribe',
  className = '',
}: NewsletterSubscriptionProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email?.trim()) {
      setMessage({ type: 'error', text: 'Please enter your email address' });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const { data, error } = await newsletterService.subscribe({ email });

      if (error) {
        setMessage({ type: 'error', text: error.message });
      } else if (data) {
        setMessage({ type: 'success', text: 'Successfully subscribed to our newsletter!' });
        setEmail('');
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'An unexpected error occurred. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-component-id="src/components/common/NewsletterSubscription.tsx:48:4" data-component-path="src/components/common/NewsletterSubscription.tsx" data-component-line="48" data-component-end-line="77" data-component-file="NewsletterSubscription.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`newsletter-subscription ${className}`}>
      <form data-component-id="src/components/common/NewsletterSubscription.tsx:49:6" data-component-path="src/components/common/NewsletterSubscription.tsx" data-component-line="49" data-component-end-line="66" data-component-file="NewsletterSubscription.tsx" data-component-name="form" data-component-content="%7B%22elementName%22%3A%22form%22%2C%22className%22%3A%22flex%20flex-col%20sm%3Aflex-row%20gap-2%22%7D" onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
        <input data-component-id="src/components/common/NewsletterSubscription.tsx:50:8" data-component-path="src/components/common/NewsletterSubscription.tsx" data-component-line="50" data-component-end-line="58" data-component-file="NewsletterSubscription.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22email%22%2C%22value%22%3A%22%5Bvar%3Aemail%5D%22%2C%22className%22%3A%22flex-1%20px-4%20py-2%20border%20border-gray-300%20rounded-md%20focus%3Aring-2%20focus%3Aring-blue-500%20focus%3Aborder-transparent%20disabled%3Abg-gray-100%20disabled%3Acursor-not-allowed%20text-black%22%7D"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={placeholder}
          disabled={loading}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed text-black"
          required
        />
        <button data-component-id="src/components/common/NewsletterSubscription.tsx:59:8" data-component-path="src/components/common/NewsletterSubscription.tsx" data-component-line="59" data-component-end-line="65" data-component-file="NewsletterSubscription.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22submit%22%2C%22className%22%3A%22px-6%20py-2%20bg-blue-600%20text-white%20rounded-md%20hover%3Abg-blue-700%20disabled%3Abg-gray-400%20disabled%3Acursor-not-allowed%20transition-colors%22%7D"
          type="submit"
          disabled={loading}
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? 'Subscribing...' : buttonText}
        </button>
      </form>
      
      {message && (
        <div data-component-id="src/components/common/NewsletterSubscription.tsx:69:8" data-component-path="src/components/common/NewsletterSubscription.tsx" data-component-line="69" data-component-end-line="75" data-component-file="NewsletterSubscription.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          className={`mt-2 p-3 rounded-md ${
            message.type === 'success' ?'bg-green-100 text-green-800 border border-green-200' :'bg-red-100 text-red-800 border border-red-200'
          }`}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}